import { AccordionRootElement } from '@typedream/components';
import {
  AccordionElement as AccordionElementType, DreamValue,
} from '@typedream/core';
import { PlateRenderElementProps } from '@udecode/plate-core';
import { pick } from 'lodash';

export function AccordionRootElementEditor(
  props: PlateRenderElementProps<DreamValue, AccordionElementType>,
) {
  return (
    <AccordionRootElement
      {...pick(props, ['element', 'className', 'attributes', 'children'])}
      expandAll
    />
  );
}
